<div class="section-container" id="aggIvtRisk">
  <div class="section-header">
    <div class="title-cont">
      <img src="/assets/icons/icon-warning.svg" width="26" height="26" alt="Traffic Quality Risk Icon" />
      <h2>Traffic Quality Risk</h2>
    </div>
    <h3 class="sub-title">Measuring the app developer’s risk for data sharing with undisclosed third parties via
      advertising fraud and invalid traffic (IVT) levels, based on Pixalate's MRC-accredited detection systems.</h3>
  </div>

  <div class="sub-section">
    <div class="d-flex align-items-center w-100">
      <app-svg-icons [svg]="SVGS.safeAdRisk" [risk]='riskOverview?.trafficQualityRisk'></app-svg-icons>
      <h3 class="ml-1">Unsafe Advertising Risk</h3>
      <i class="fa fa-info-circle ml-2 mr-auto" enTooltip [attr.title]="TOOLTIPS.aggIvtRisk"></i>
      <risk-heat-meter version="v3" [risk]='riskOverview?.trafficQualityRisk'></risk-heat-meter>
    </div>
  </div>
</div>